import type { RateCardListQuery } from '@chukua/common';
import { Tag, type TableColumnsType } from 'antd';
import { Link } from 'react-router';
import type { ListQueryControls } from '../../../shared/hooks/use-list-query';
import { DeactivateRateCardButton } from './DeactivateRateCardButton';
import { rateCardPath } from '../rate-cards.paths';
import type { RateCardView } from '../rate-cards.api';

interface BuildRateCardColumnsArgs {
  list: Pick<ListQueryControls<RateCardListQuery>, 'sortOrderFor' | 'filteredValueFor'>;
  canEdit: boolean;
  onDeactivated: () => void;
}

const STATUS_FILTERS = [
  { text: 'Active', value: 'active' },
  { text: 'Inactive', value: 'inactive' },
];

export function rateCardName(card: Pick<RateCardView, 'customerName'>): string {
  return card.customerName ?? 'Standard rate card';
}

/** Sorting and filtering run on the server: each column's `key` is its `sort` field or filter param in `rateCardListQuerySchema`. */
export function buildRateCardColumns({ list, canEdit, onDeactivated }: BuildRateCardColumnsArgs): TableColumnsType<RateCardView> {
  return [
    {
      title: 'Rate card',
      key: 'name',
      render: (_, card) => (
        <Link className="font-medium text-link hover:underline" to={rateCardPath(card.id)}>
          {rateCardName(card)}
        </Link>
      ),
    },
    {
      title: 'Status',
      key: 'status',
      filters: STATUS_FILTERS,
      filteredValue: list.filteredValueFor('status'),
      render: (_, card) => <Tag color={card.isActive ? 'success' : 'default'}>{card.isActive ? 'Active' : 'Inactive'}</Tag>,
    },
    {
      title: 'Created',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: true,
      sortOrder: list.sortOrderFor('createdAt'),
      render: (createdAt: string) => new Date(createdAt).toLocaleDateString(),
    },
    {
      title: '',
      key: 'actions',
      render: (_, card) => (canEdit ? <DeactivateRateCardButton card={card} onDeactivated={onDeactivated} /> : null),
    },
  ];
}
